import { waLink, trackEvent } from "../lib/api";

const WhatsAppFloat = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with AccuSurge on WhatsApp"
    data-testid="whatsapp-float-button"
    onClick={() => trackEvent("whatsapp_click", { source: "float_button" })}
    className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_32px_rgba(37,211,102,0.45)] transition-transform duration-200 hover:scale-105 active:scale-95"
  >
    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="currentColor" aria-hidden="true">
      <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 2a8 8 0 1 1-4.1 14.9l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 0 1 12 4Zm-3 4c-.2 0-.5 0-.7.3-.2.3-.9.9-.9 2.1 0 1.2.9 2.4 1 2.6.1.2 1.7 2.8 4.3 3.8 2.1.8 2.6.7 3 .6.5 0 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.6-.3l-2-.9c-.3-.1-.5-.1-.7.1l-.9 1.1c-.2.2-.3.2-.6.1a6.5 6.5 0 0 1-3.2-2.8c-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6L9.7 8.4C9.6 8 9.4 8 9.2 8H9Z" />
    </svg>
    <span className="absolute -top-0.5 -right-0.5 flex h-3.5 w-3.5">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-60" />
      <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-accent border-2 border-white" />
    </span>
  </a>
);

export default WhatsAppFloat;
